/*  global _ */
const EventBus = window.VueEventBus

import config from '../../../lib/config'
import {parseNumber, getQS} from '../../../lib/utils'
import {getNow, parseDateTime} from '../../../lib/dates'

const {
  supercharged,
  TIMEZONE,
} = config

let {DEFAULT_BOOKING_TIMEOUT: timerTimeout = 1800} = config
const qs = getQS() || {}
timerTimeout = (1 * qs.timeout) || (timerTimeout - 10)

const bookingBuffer = 0
import PageMixins from '../../../components/_mixins/pages'
import ReservationMixins from '../mixin/tickets'
import CartMixins from '../../../components/_mixins/location-checkout'
import ScrollMixins from '../../../components/_mixins/scroller'
import PersonalDetailsMixins from '../../../components/_mixins/personal-details'
import BookingMixin from '../../../components/_mixins/booking'
import StepsMixins from './steps'
const mixins = [
  ReservationMixins,
  PageMixins,
  CartMixins,
  ScrollMixins,
  PersonalDetailsMixins,
  StepsMixins,
  BookingMixin
]

import WouldYouLikeTo from '../../../components/parts/would-you-like-to'

import AgreeToTerms from '../../../components/parts/AgreeToTerms'
import TimeslotSelectorBox from './parts/timeslot-selector-box'
import MiniCart from './parts/mini-cart'

const components = {
  AgreeToTerms,
  TimeslotSelectorBox,
  MiniCart,
  WouldYouLikeTo,
}

export default {
  name: 'page-book-ticket',
  settings: 'page.book-ticket',
  translations: 'page.book-ticket',
  components,
  mixins,
  data() {
    return {
      timeZone: TIMEZONE,
      showQuantityLimitPrompt: false,
      freezeSlotRetrieval: false,
      editMode: false,
      editingId: null,
      numTickets: null,
      numTicketsReset: null,
      useEmail: true, //true: enable email and emailConfirmation fields in personal details box
      contactPhone: supercharged.phone_with_extension || '774-847-9010,101',
      isAddingToCart: false,
    }
  },
  computed: {
    contactPhoneExt() {
      return this.contactPhone.replace(',', ' ext. ')
    },
    moreThanQuantityLimit() {
      return this.quantity > this.quantityLimit
    },
  },
  watch: {
    showMiniCart(newValue, oldvalue) {
      if (this.preventTimerStartInEditMode) {
        return
      }
      // handle global cart timer
      if (newValue) {
        // start timer if no timer is running already
        if (!this.timerIsRunning) {
          const holdStartsAt = this.holdStartsAt = getNow().toSeconds()
          this.holdEndsAt = (1 * holdStartsAt) + timerTimeout
          this.startTimer(timerTimeout)
        }
        if (!this.holdStartsAt || !this.holdEndsAt) {
          this.holdStartsAt = parseDateTime(this.timerStartTime).toSeconds()
          this.holdEndsAt = parseDateTime(this.timerEndTime).toSeconds()
        }
      } else {
        // stop timer if cart does not have any timer running
        if (!this.needsToShowTimer) {
          this.holdStartsAt = null
          this.holdEndsAt = null
          this.stopTimer()
        }
      }
    },
    async selectedDate(newValue, oldValue) {
      if (_.isObject(newValue)) {
        newValue = null
      }
      if (newValue && !this.freezeSlotRetrieval) {
        newValue = ('' + newValue).trim()
        await this.retrieveTimeslots(newValue)
      }
      this.freezeSlotRetrieval = false
    },
    numTickets(val, oldVal) {
      if (!this.numTicketsReset) {
        this.watchNumTickets()
      }
      this.numTicketsReset = null
    },
    quantity(val, oldVal) {
      if (this.isHydratingData) {
        this.numTickets = val
      }
      this.watchNumTickets()
      if (val < oldVal) {
        this.cleanTimeslots()
      }
    },
    moreThanQuantityLimit(value) {
      if (value) {
        this.$nextTick(() => {
          this.showPrompts()
        })
      }
    }
  },
  async created() {
    this.loadEditable()
    this.hideGlobalTimer(true)
    this.editMode = !!this.bookingEditItem
    if (!this.editMode) {
      this.mayResetCountdownTimer()
    }
    if (this.editMode) {
      this.editingId = this.bookingEditItem.id
    }

    const vm = this
    EventBus.$on('cart-item-edit-reservations', async (item, cartItem, cart) => {
      await this.hydrateFromCart(item, cartItem, cart)
      this.scrollToDate()
    })
    EventBus.$on('cart-item-added-reservations', (item, cartItem, cart) => {

    })
    EventBus.$on('cart-item-deleted-reservations', (item, cartItem, cart) => {
      this.cleanTimeslots()
      this.unsetLocalCartItem(item)
      this.scrollToDate()
    })
    EventBus.$on('cart-cleaned', cart => {
      this.cleanTimeslots()
      this.clearLocalCart()
      this.scrollToDate()
    })

    EventBus.$on('timer.timeout', id => {
      if (id === this.currentLocationId) {
        const editMode = this.editMode
        const canAutoRemove = this.autoRemoveCartItemOnTimeout
        if (canAutoRemove) {
          this.cleanExistingItems()
        } else {
          this.cleanSelectedTimeslots()
        }
        let message = 'Time to hold your selection for reservation has expired.'
        if (editMode && canAutoRemove) {
          message += ' Your cart item has been removed.'
        }
        message += ' Please start over again!'

        this.scrollToDate()
        this.alert(message, {classes: 'text-danger'})
      }
    })

    if (this.editMode) {
      const expired = this.hasExpired(this.bookingEditItem)
      if (expired) {
        EventBus.$emit('timer.timeout', this.currentLocationId)
        this.mayResetCountdownTimer()
      }
      if (!expired || !this.autoRemoveCartItemOnEditTimeout) {
        EventBus.$emit('cart-item-edit-reservations', this.bookingEditItem)
      }
    }
  },
  methods: {
    watchNumTickets(event) {
      const newValue = Math.max(0, Math.round(this.numTickets) || 0)
      this.numTickets = this.numTickets === '' ? '' : newValue
      this.askAndRemoveSelectedTimeSlot(
        'change in the number of tickets',
        () => {
          if (this.quantity !== newValue) {
            this.quantity = parseNumber(newValue)
            this.$nextTick(() => {
              this.showPrompts()
            })
          }

        },
        () => {
          if (this.quantity !== this.numTickets) {
            this.numTicketsReset = true
            this.numTickets = this.quantity
          }
        },
        () => {

        }
      );
    },
    watchChosenDate(newValue) {
      if (_.isObject(newValue)) {
        newValue = null
      }
      if (newValue) {
        newValue = ('' + newValue).trim()
         if (!_.isEmpty(this.selectedTimeslots)) {
          this.askAndRemoveSelectedTimeSlot('change in date',
            () => {
              this.selectedDate = newValue
            },
            () => {
              this.chosenDate = this.selectedDate
            },
          )
         } else {
           this.selectedDate = newValue
         }
      }
    },
    hasExpired(item) {
      let expired = this.hasTimerExpired(item)
      if (!expired) {
        const earliestSlotTime = this.getEarliestSlotTime(item)
        if (earliestSlotTime) {
          expired = getNow(this.timezone, true) >= (earliestSlotTime - (bookingBuffer * 60))
        }
      }
      return expired
    },
    hasTimerExpired(item) {
      const ends = 1 * _.get(item, 'payload.options.form.holdEndsAt', 0)
      if (ends) {
        return getNow().toSeconds() >= ends
      }
      return false

    },
    navigateToBookEvents() {
      window.location.assign(config.GROUP_EVENTS_URL)
    },
    addToLocalCart(data) {
      const prevCartId = this.input('cartId')
      if (prevCartId) {
        this.unsetLocalCartItem({date: prevCartId})
      }

      const date = parseDateTime(this.selectedDate).toISODate()
      this.setInput({cartId: date})
      const slots = _.clone(this.retrievedTimeslots, true)
      const inputs = _.clone(this.input(), true)
      this.setLocalCartItem({date, slots, inputs})
    },
    cleanSelectedTimeslots() {
      _.forOwn(this.selectedAllTimeslots, slot => {
        this.unholdSlot(slot)
      })
      this.cleanTimeslots()
    },
    cleanExistingItems() {
      this.cleanSelectedTimeslots()
      this.clearLocalCart()
      if (this.editMode) {
        this.removeExitingCartItems(this.editingId)
        this.editMode = false
      }
    },
    async removeExitingCartItems(id) {
      const mainItem = this.cartItem(id)
      if (mainItem) {
        await this.removeCartItem({id})
      }
      this.editingId = null
    },
    hasExistingCartItem() {
      const cart = _.filter(this.currentCartItems || {}, ({type}) => type === this.reservationType)
      if (!this.editingId && !_.isEmpty(cart)) {
        const cartIds = _.reduce(cart, (items, {id}) => ({[id]: true, ...items}), {})
        const proposed = _.filter(this.proposedCart, ({type}) => type === this.reservationType)
        const proposedIds = _.reduce(proposed, (items, {id}) => [id, ...items], [])
        return _.some(proposedIds, id => cartIds[id] || false)
      }
      return false
    },
    async addToCart(goto = true) {
      await this.finallyAddToCart(goto)
    },
    async finallyAddToCart(goto) {
      this.isAddingToCart = true
      const cartPage = 'page-cart'
      this.addToLocalCart()

      if (this.editingId || this.hasExistingCartItem()) {
        await this.removeExitingCartItems(this.editingId)
      }
      await this.$nextTick()
      await this.addCartItems(this.proposedCart)
      this.setBookingEditItem(null)
      if (goto) {
        await this.$nextTick()
        this.goto(cartPage)
      } else {
        this.isAddingToCart = false
      }
    },
    showPrompts: _.debounce(function () {
      this.showQuantityLimitPrompt = this.moreThanQuantityLimit
    }, 500),
    async hydrateFromCart(cartItem) {
      this.startHydratingData(true)
      const hasExpired = this.hasExpired(cartItem)
      this.freezeSlotRetrieval = true
      const {attributes, cartId} = cartItem
      const {form: inputs} = attributes
      const selectedSlots = hasExpired ? {} : _.clone(inputs.selectedSlots)
      const otherInputs = _.clone(_.omit(inputs, ['selectedSlots']))
      this.setInput(otherInputs)
      this.phoneConfirmation = _.get(otherInputs, 'contact.phone')
      if (this.useEmail) {
        this.emailConfirmation = _.get(otherInputs, 'contact.email')
      }
      this.chosenDate = this.selectedDate
      await this.$nextTick()
      const timeslots = await this.retrieveTimeslots(inputs.selectedDate)

      this.selectedSlots = hasExpired ? {} : inputs.selectedSlots

      await this.$nextTick()
        // this.setInput({selectedSlots})
      _.forOwn(selectedSlots, slot => {
        // // const setTimeslot = this.retrievedTimeslot(slot.time)
        const {time, selected, participants, hold} = slot
        const data = [
          {time, key: 'selected', value: true},
          {time, key: 'participants', value: participants},
          {time, key: 'hold', value: hold}
        ]
        this.setRetrievedTimeslotDataItems(data)
        const updates = {time, selected, participants, hold}
        this.setTimeslot(updates)
      })

      await this.$nextTick()
      if (hasExpired) {
        this.cleanSelectedTimeslots()
      }

      this.$forceUpdate()
      await this.$nextTick()

      this.setBookingEditItem(null)
      this.startHydratingData(false)
      this.preventTimerResetInEditMode = false
    },
    loadEditable() {
      const token = this.$route.query.token || _.get(getQS(), 'token')
      if (token) {
        const item = _.find(this.currentCartItems, ({id}) => id === token)
        this.setBookingEditItem(_.cloneDeep(item))
      }
    },
    scrollToDate() {
      this.$nextTick(() => {
        this.scrollTo('.booking-date-input-box')
      })
    },
    async likeClick() {
      if (!this.cartNotReady) {
        await this.addToCart(false)
      }
    },
  }

}
